<template>
  <div class="gen-qr-code-container">
    <div class="parameterSelection flex-col align-center">
      <div class="title">生成二维码</div>

      <el-form class="form_container" ref="form" :model="form" label-width="80px">

        <el-form-item label="门店选择">
          <el-select v-model="form.posKeyWords"
                     filterable
                     placeholder="请选择或输入门店名称"
                     @change="getCurrentPosId"
          >
            <el-option
                v-for="item in posList"
                :key="item.pos.id"
                :label="item.pos.name"
                :value="item.pos.posId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="扫码进入">
          <el-select v-model="form.pageState" placeholder="请选择页面参数">
            <el-option
                v-for="item in pageParams"
                :key="item.value"
                :label="item.name"
                :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="使用方式">
          <el-select v-model="form.codeType" placeholder="请选择成码类型">
            <el-option
                v-for="item in codeTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="边长设置">
          <el-input v-model="form.sideLength" placeholder="请设置二维码边长"></el-input>
        </el-form-item>

      </el-form>

      <el-button class="button" type="primary" @click="getQrCode">生成二维码</el-button>
    </div>

    <img :src="qrcodeDataUrl" alt="">

  </div>
</template>

<script>
import {generateQrcode, getPosByPosName} from "../api/axios/generate-qrcode";
import QRCode from "qrcode";

export default {
  name: 'GenQrCode',
  data() {
    return {
      loading: false,
      posList: [],
      form: {
        posKeyWords: '',
        logoId: 'zm',
        codeType: '6',
        sideLength: '200',
        pageState: '11'
      },

      pageParams: [{
        name: '服务购买页',
        value: '11',
      },{
        name: '链点明细页',
        value: '21',
      },{
        name: '用户资料页',
        value: '22',
      },{
        name: '订单记录页',
        value: '23',
      }],

      codeTypeList: [{
        name: '模版消息推送-临时二维码',
        value: '3'
      }, {
        name: '模版消息推送-长期二维码',
        value: '4'
      }, {
        name: '扫码进页面-临时二维码',
        value: '5'
      }, {
        name: '扫码进页面-长期二维码',
        value: '6'
      },],

      posId: '',
      ver: '',

      logoImg: require('../assets/the_logo.png'),
      qrCodeUrl: '',

      qrcodeDataUrl: '',

      snOfPartnerId: null
    }
  },
  mounted() {
    this.getAllPosList();
  },
  methods: {
    // 查询商户下对应的门店
    getAllPosList() {
      if (sessionStorage.getItem('partnerid') === 'M2022060601') {
        console.log('当前为众敏商户');
        getPosByPosName().then(res => {
          console.log('查询出所有门店信息', res);
          if (res.data.queryPosInfo) {
            this.posList = res.data.queryPosInfo;
          } else {
            console.log('门店查询异常');
          }
        }).catch(error => {
          console.log('查询门店信息异常', error);
        })
      } else {
        getPosByPosName({
          partnerId: sessionStorage.getItem('partnerid')
        }).then(res => {
          console.log('查询出所有门店信息', res);
          if (res.data.queryPosInfo) {
            this.posList = res.data.queryPosInfo;
          } else {
            console.log('门店查询异常');
          }
        }).catch(error => {
          console.log('查询门店信息异常', error);
        })
      }
    },

    getCurrentPosId() {
      console.log('获取当前posId');
      console.log('this.form.posKeyWords', this.form.posKeyWords);
      for (const item of this.posList) {
        console.log('开始遍历');
        if (this.form.posKeyWords === item.pos.posId) {
          console.log('posKeyWords', item.pos.posId);
          this.posId = item.pos.posId;
          console.log('当前门店', item.pos);
          if (item.pos.washerType === 3) {
            this.snOfPartnerId = item.device.snOfPartnerId;
          } else {
            this.snOfPartnerId = null;
          }
          break;
        }
      }

    },

    // 生成二维码
    getQrCode() {
      generateQrcode({
        deviceID: this.posId, // 门店Id
        cmd: 'washGuide',
        ver: this.form.codeType,      // 二维码类型 3 临时二维码 4 长期二维码 5 自定义二维码-临时 6 自定义二维码-长期
        agentID: sessionStorage.getItem('openid'),  // 二维码生成者id
        pageNo: this.form.pageState
      }).then(res => {
        console.log('生成二维码', res);

        if (res.data.retcode < 0) {
          alert(`${res.data.retmsg}`)
        } else {
          this.qrCodeUrl = res.data.url;
          if (this.qrCodeUrl.includes('testomc')) {
            this.qrCodeUrl = this.qrCodeUrl.replace('testomc', 'testzmcf')
          } else if (this.qrCodeUrl.includes('omc')) {
            this.qrCodeUrl = this.qrCodeUrl.replace('omc', 'zmxcl')
          } else {
            alert('当前url异常！')
          }

          this.renderQrCode();
        }
      }).catch(error => {
        console.log('生成二维码失败', error);
        alert(error);
      })
    },

    // 渲染出二维码
    async renderQrCode() {
      const text = this.qrCodeUrl; // 二维码内容
      console.log('二维码内容', text);
      const size = this.form.sideLength; // 二维码大小
      const logoUrl = require('../assets/the_logo.png'); // Logo图片路径
      const additionalText = `编号：${this.snOfPartnerId}`; // 要添加的文字
      let that = this;

      console.log('文字显示', additionalText);
      // 生成二维码的数据URL
      const qrcodeDataUrl = await new Promise((resolve, reject) => {
        QRCode.toDataURL(text, {type: 'image/png', width: size, height: size}, (err, url) => {
          if (err) {
            reject(err);
          } else {
            resolve(url);
          }
        });
      });

      // 加载Logo图片并绘制到Canvas上的二维码中间
      const img = new Image();
      img.src = logoUrl;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 设置Canvas大小与二维码相同
        canvas.width = size;
        canvas.height = String(Number(size) + 30);

        // 设置背景颜色并填充Canvas
        const backgroundColor = '#FFFFFF'; // 这里设置您想要的背景颜色，例如白色
        ctx.fillStyle = backgroundColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // 绘制二维码到Canvas上
        const qrcodeImage = new Image();
        qrcodeImage.src = qrcodeDataUrl;
        qrcodeImage.onload = () => {
          ctx.drawImage(qrcodeImage, 0, 0, size, size);

          // 计算Logo的位置（居中）
          const logoSize = Math.min(size * 0.3, img.width, img.height); // Logo最大为二维码尺寸的30%
          const x = (size - logoSize) / 2;
          const y = (size - logoSize) / 2;

          // 绘制Logo到二维码中间
          ctx.drawImage(img, x, y, logoSize, logoSize);

          // 充电桩门店添加编号
          if (that.snOfPartnerId) {
            ctx.font = '15px Arial';
            ctx.fillStyle = 'black';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom'; // 文字基线对齐到Canvas底部

            // 计算文字的位置
            const textYPosition = Number(that.form.sideLength) + 10; // 确保文字在二维码下方

            // 在二维码下方添加文字
            ctx.fillText(additionalText, size / 2, textYPosition);
          }

          // 将Canvas转换为图片数据URL
          that.qrcodeDataUrl = canvas.toDataURL('image/png');
        };
      };
    },
  }
}
</script>

<style lang="scss" src="../css/gen-qr-code.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/gen_qr_code.vue